<li class="nav-item active">
  <a [routerLink]="item.link" class="nav-link"><i *ngIf="item.icon" [class]="item.icon"></i> {{ item.nome }}</a>
</li>
